 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-08270d64":"a4716346","chunk-0b5083c9":"183bd4f5","chunk-0e3ada36":"f5b419de","chunk-109f4ac8":"96fc7fc1","chunk-124253f6":"4a481284","chunk-1abd2a85":"f4255119","chunk-1c8776c6":"5abb7afc","chunk-2d216214":"dda534f6","chunk-48fc8d29":"28a415e3","chunk-4adfc2cb":"a941ef5d","chunk-4ee193ba":"8dd1b68d","chunk-5c354cbe":"cd6cdcbd","chunk-6476a80f":"38c275fa","chunk-66499f86":"60b0378a","chunk-6f8dca74":"9599bf27","chunk-7e4eac9a":"e0ec722b","chunk-90fb105e":"802c3592","chunk-955104b2":"5b67010a","chunk-dbb8d16a":"c461667a","chunk-0891119c":"8b1fbf07","chunk-51c35f17":"1ea4b445","chunk-1e5897a6":"dafa9d09","chunk-2d0c5046":"fbc95503","chunk-165170c0":"e332c4d0","chunk-31129060":"75b533e1","chunk-60ca6838":"9bf2e3dc","chunk-110c7462":"84a2034b","chunk-12cdb9e4":"a13ff15a","chunk-34a52f8c":"26253b78","chunk-0e7753bf":"da554f04","chunk-1f832b0f":"94c5fff7","chunk-54441e99":"d973914f","chunk-582f162e":"bb4fc7ef","chunk-5a4deb79":"762bbecf","chunk-5e70a546":"661a108d","chunk-8707e908":"60d2e2c0","chunk-8f516e26":"aead24f5","chunk-c3c8c8bc":"d64b9841","chunk-d7a826f4":"dfc614d7","chunk-9b2bbdd2":"7c6b96f2","chunk-f3f79a2a":"9a4baf25","chunk-9f6e810a":"41ab7283","chunk-3377a62a":"84ecd928","chunk-2d0bdd64":"b76c3662","chunk-e49978e8":"7b0f582a","chunk-3b57d365":"a6121bdd","chunk-9332d9aa":"f9edf241","chunk-9475d680":"40a9371c","chunk-361c9c0a":"2866a736","chunk-67355449":"da15a4b8","chunk-dc51ebe2":"550a69ac","chunk-e58aaa66":"018b46f1","chunk-fdd8e336":"a161121b","chunk-06da49da":"29e71d3a","chunk-7aa3c928":"81671428","chunk-1e90db16":"4ce254d1","chunk-493027cc":"405f2519","chunk-cf67f430":"dc38288e","chunk-052f9ba4":"76124107","chunk-2457ad77":"eaec3c14"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-08270d64":1,"chunk-0b5083c9":1,"chunk-0e3ada36":1,"chunk-109f4ac8":1,"chunk-124253f6":1,"chunk-1abd2a85":1,"chunk-1c8776c6":1,"chunk-4adfc2cb":1,"chunk-4ee193ba":1,"chunk-5c354cbe":1,"chunk-6476a80f":1,"chunk-66499f86":1,"chunk-6f8dca74":1,"chunk-7e4eac9a":1,"chunk-90fb105e":1,"chunk-955104b2":1,"chunk-0891119c":1,"chunk-51c35f17":1,"chunk-1e5897a6":1,"chunk-165170c0":1,"chunk-31129060":1,"chunk-60ca6838":1,"chunk-110c7462":1,"chunk-12cdb9e4":1,"chunk-34a52f8c":1,"chunk-0e7753bf":1,"chunk-1f832b0f":1,"chunk-54441e99":1,"chunk-582f162e":1,"chunk-5a4deb79":1,"chunk-5e70a546":1,"chunk-8707e908":1,"chunk-8f516e26":1,"chunk-c3c8c8bc":1,"chunk-d7a826f4":1,"chunk-9b2bbdd2":1,"chunk-f3f79a2a":1,"chunk-9f6e810a":1,"chunk-3377a62a":1,"chunk-e49978e8":1,"chunk-3b57d365":1,"chunk-9332d9aa":1,"chunk-9475d680":1,"chunk-361c9c0a":1,"chunk-67355449":1,"chunk-dc51ebe2":1,"chunk-e58aaa66":1,"chunk-fdd8e336":1,"chunk-06da49da":1,"chunk-7aa3c928":1,"chunk-1e90db16":1,"chunk-493027cc":1,"chunk-cf67f430":1,"chunk-052f9ba4":1,"chunk-2457ad77":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-08270d64":"103a91fd","chunk-0b5083c9":"45edca38","chunk-0e3ada36":"4f5f0398","chunk-109f4ac8":"1d625a7c","chunk-124253f6":"07de9686","chunk-1abd2a85":"50b68e6d","chunk-1c8776c6":"3e78ab7e","chunk-2d216214":"31d6cfe0","chunk-48fc8d29":"31d6cfe0","chunk-4adfc2cb":"f11f55ef","chunk-4ee193ba":"17867a5c","chunk-5c354cbe":"93ada9a8","chunk-6476a80f":"1a76c22c","chunk-66499f86":"9fc1bc80","chunk-6f8dca74":"7f83dc02","chunk-7e4eac9a":"f9daf5c4","chunk-90fb105e":"2194c86f","chunk-955104b2":"e09165c6","chunk-dbb8d16a":"31d6cfe0","chunk-0891119c":"921db707","chunk-51c35f17":"f70b87f0","chunk-1e5897a6":"979d4ec0","chunk-2d0c5046":"31d6cfe0","chunk-165170c0":"3dc4d8e8","chunk-31129060":"c96ada82","chunk-60ca6838":"5ac8bbe8","chunk-110c7462":"1fc861cf","chunk-12cdb9e4":"209ba786","chunk-34a52f8c":"467eab15","chunk-0e7753bf":"f658bb54","chunk-1f832b0f":"74a903ca","chunk-54441e99":"368e4655","chunk-582f162e":"26e88400","chunk-5a4deb79":"e7578fa0","chunk-5e70a546":"9ce074fa","chunk-8707e908":"2743cf1b","chunk-8f516e26":"26e88400","chunk-c3c8c8bc":"8e6d08c5","chunk-d7a826f4":"b796ca54","chunk-9b2bbdd2":"d5fb3050","chunk-f3f79a2a":"6616ea52","chunk-9f6e810a":"4e8523fa","chunk-3377a62a":"3011d77b","chunk-2d0bdd64":"31d6cfe0","chunk-e49978e8":"1c3e4b7c","chunk-3b57d365":"2332a576","chunk-9332d9aa":"853393d6","chunk-9475d680":"c7eea132","chunk-361c9c0a":"b17dfc1c","chunk-67355449":"1717df1f","chunk-dc51ebe2":"b76ecc4b","chunk-e58aaa66":"2194c86f","chunk-fdd8e336":"3e6e5e56","chunk-06da49da":"2d1d5ac5","chunk-7aa3c928":"30f392fc","chunk-1e90db16":"d876ce9d","chunk-493027cc":"c1bd8f21","chunk-cf67f430":"c47f8d91","chunk-052f9ba4":"81db496c","chunk-2457ad77":"7f40e015"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://sokogate.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["chunk-dbb8d16a","chunk-2d0c5046","chunk-165170c0","chunk-0891119c","chunk-60ca6838","chunk-31129060","chunk-12cdb9e4","chunk-54441e99","chunk-51c35f17","chunk-3377a62a","chunk-e49978e8","chunk-2d0bdd64","chunk-109f4ac8","chunk-5c354cbe","chunk-fdd8e336","chunk-955104b2","chunk-0e3ada36","chunk-124253f6","chunk-dc51ebe2","chunk-7e4eac9a","chunk-6f8dca74","chunk-1c8776c6"]]);
 	return startupResult;
